import { render, staticRenderFns } from "./GoodOrderLeaveMessage.vue?vue&type=template&id=70493ae2&scoped=true&"
import script from "./GoodOrderLeaveMessage.vue?vue&type=script&lang=js&"
export * from "./GoodOrderLeaveMessage.vue?vue&type=script&lang=js&"
import style0 from "./GoodOrderLeaveMessage.vue?vue&type=style&index=0&id=70493ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70493ae2",
  null
  
)

export default component.exports